"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _instrumentActions = require("../actions/instrumentActions");
var _recalculateOrderHelper = require("../../helpers/recalculateOrderHelper");
var _orderHelper = require("../../helpers/orderHelper");
var _userActions = require("../actions/userActions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for recalculate order fee and total amount when order entry form values are changed (default and advanced)
 */
var placeOrderMiddleware = function placeOrderMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
        form = _store$getState.form,
        level2 = _store$getState.apexCore.level2;
      var advancedOrderEntryFormIsInitialized = !!form.advancedOrderEntry;
      var reportBlockTradeFromIsInitialized = !!form.reportBlockTrade;
      if ((0, _recalculateOrderHelper.isOrderEntryFormChanged)(action)) {
        if (action.meta.field === 'instrument') {
          store.dispatch((0, _instrumentActions.selectInstrument)(parseInt(action.payload, 10)));
          return next(action);
        }
        var orderEntryForm = form.orderEntry;
        if (advancedOrderEntryFormIsInitialized) {
          orderEntryForm = form.advancedOrderEntry;
        } else if (reportBlockTradeFromIsInitialized) {
          orderEntryForm = form.reportBlockTrade;
        }
        var updatedForm = _objectSpread(_objectSpread({}, orderEntryForm.values), {}, _defineProperty({}, action.meta.field, action.payload));
        (0, _recalculateOrderHelper.recalculateOrderFormValues)(store, {
          form: updatedForm,
          formName: action.meta.form,
          orders: (0, _orderHelper.getOrdersBySide)(updatedForm.side, level2)
        });
        return next(action);
      }

      // reload fees when instrument is changed, otherwise wrong symbol is shown
      if ((action.type === _instrumentActions.SET_INSTRUMENT || action.type === _userActions.SET_ACCOUNT) && form.orderEntry) {
        // first recalculate next store's state to update the selected instrument
        // used by the recalculateOrderFormValues function.
        var retVal = next(action);
        (0, _recalculateOrderHelper.recalculateOrderFormValues)(store, {
          form: form.orderEntry.values,
          formName: 'orderEntry',
          orders: (0, _orderHelper.getOrdersBySide)(form.orderEntry.values.side, level2)
        });
        return retVal;
      }
      return next(action);
    };
  };
};
var _default = exports["default"] = placeOrderMiddleware;